/**
 *  In all cases in our platform the label hangs over the card-book img cover. But in Cargo there is a special wish to put this label on the bottom of the card.
 *  Since it's not part of the layout structure (it lives in the img-container), and absolute positioning is not applicable since we do not know the height of the
 *  card.
 */
const adjustBookCardLayout = () => {
    let bookCard = $('.card-book');

    bookCard.each(function() {
        if($(this).find('.label-book')) {
            let labelBook = $(this).find('.label-book');
            let authorContainer = $(this).find('.author-container');

            if(labelBook.length > 0) {
                labelBook.insertAfter(authorContainer);
            }
        }

        if($(this).find('.label-serie-nr')) {
            let labelSerieNo = $(this).find('.label-serie-nr');
            let authorContainer = $(this).find('.author-container');

            if(labelSerieNo.length > 0) {
                labelSerieNo.insertAfter(authorContainer);
            }
        }
    });
}

$(window).on('load ajaxComplete', function () {
    adjustBookCardLayout();
});